import React from 'react';

import { IModalProps } from 'views/Offers/BuyOneGetMany/Form/BuyOneGetManyForm.types';

import DialogModal from 'components/DialogModal/DialogModal';

const BuyOneGetManyModals: React.FC<IModalProps> = ({
  isSaveDialogOpen,
  isUpdateDialogOpen,
  setIsSaveDialogOpen,
  setIsUpdateDialogOpen,
  submitForm
}): React.ReactElement => {
  return (
    <React.Fragment>
      {isUpdateDialogOpen && (
        <DialogModal
          isOpen={isUpdateDialogOpen}
          title="1+Many is currently live"
          description="Your changes will update automatically"
          dataTestId="buyOneGetManyUpdateDialog"
          modalActions={{
            onConfirm: {
              label: 'Update',
              action: submitForm
            },
            onClose: {
              label: 'Cancel',
              action: () => setIsUpdateDialogOpen(false),
              variant: 'outline'
            }
          }}
        />
      )}
      {isSaveDialogOpen && (
        <DialogModal
          isOpen={isSaveDialogOpen}
          title="Please note"
          description="No products were selected"
          modalActions={{
            onConfirm: {
              label: 'Save',
              action: submitForm
            },
            onClose: {
              label: 'Cancel',
              action: () => setIsSaveDialogOpen(false),
              variant: 'outline'
            }
          }}
        />
      )}
    </React.Fragment>
  );
};

export default BuyOneGetManyModals;
